import React from 'react';
import Highcharts from 'highcharts';

import { ChartContent } from '../../Chart';

const StackedAreaView = ({
  chartRef,
  options,
  chartDefinitionId,
}: {
  chartRef: React.MutableRefObject<any>;
  options: Highcharts.Options;
  chartDefinitionId: string;
}) => {
  return (
    <ChartContent
      chartRef={chartRef}
      options={options}
      key={chartDefinitionId}
    />
  );
};

export default StackedAreaView;
